import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'sheed-rate',
  templateUrl: './sheed-rate.component.html',
  styleUrls: ['./sheed-rate.component.scss']
})
export class SheedRateComponent implements OnInit {
  @Input('rate') rate: number;
  @Output('rateChange') rateChange = new EventEmitter<number>();
  constructor() { }
  ngOnInit() {

  }
  change(rate:number) {
    this.rateChange.emit(rate);
  }
}
